import React, { useEffect } from "react";
import { Quiz } from "../../../../@types/quiz.interfaces";
import { GlobalState } from "../../../../redux/root-reducer";
import { Dispatch } from "redux";
import { fetchApi } from "../../../../redux/fetch/fetch.actions";
import { connect } from "react-redux";
import Loading from "../../../../components/loading/loading.component";
import ViewQuiz from "../../../../components/view-quiz/view-quiz.component";
import QuizActionAPI from "../../../../redux/quiz/quiz.actions";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    quizzes: Quiz[] | null;
    fetchQuizzes: () => void;
    clearQuizzes: () => void;
}

function ViewQuizContainer({
    isFetching,
    errors,
    quizzes,
    fetchQuizzes,
    clearQuizzes,
}: IProps) {
    useEffect(() => {
        if (isFetching || errors) return;
        if (quizzes === null) fetchQuizzes();
        return () => {
            clearQuizzes();
        };
    }, [isFetching, errors, quizzes, fetchQuizzes, clearQuizzes]);

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <div className="container__content">
                    <ViewQuiz quizzes={quizzes} />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    quiz: { quizzes },
}: GlobalState) => ({
    isFetching: isFetching.QUIZZES,
    errors: errors.QUIZZES,
    quizzes: quizzes,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchQuizzes: () => dispatch(fetchApi({ name: "QUIZZES" })),
    clearQuizzes: () => dispatch(QuizActionAPI.clearQuizzes()),
});

const ViewQuizPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewQuizContainer);

export default ViewQuizPage;
